import MarkdownComponent from './Markdown';
import Tabs from './Tabs/tabs';
import Tabs2 from './Tabs2';
import MarkdownTitleComponent from './MarkdownTitle';

export const Markdown = MarkdownComponent;
export const MarkdownTitle = MarkdownTitleComponent;
export const TabsComponent = Tabs;
export const TabsComponent2 = Tabs2;
